import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <p className="font-heading text-xs md:text-sm uppercase tracking-widest text-primary-600 font-semibold mb-3">
            All Categories
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Browse by Product Category
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Click any category to explore products on the Sugargoo Spreadsheet. Discover trending items across fashion, accessories, and more.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={cat.image}
                  alt={`Sugargoo Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  title={`Sugargoo Spreadsheet ${cat.name} category`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
              </div>
              <div className="p-3 md:p-4 flex items-center justify-between">
                <span className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 text-xs group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}